import React, { memo } from "react";
import { FilterArea } from "./FilterArea";
import { toggleFilterPanel } from './HelperFunctions'

export const FilterContainer = memo(({ setItemGroups, setItemsLoading }) => {

    return (
        <>
            {(model.filterReponseInfo?.TotalFiltersCount ?? 0) > 0 && (

                $(window).innerWidth() < 768
                    ? <div id="greyerFilters" className="tw-fixed tw-h-[100%] tw-w-[100%] tw-z-[101] tw-top-0 tw-left-0" style={{ display: "none", backgroundColor: "rgba(0,0,0,0.4)" }}>
                        <div id="mobileFilters" className="tw-flex tw-fixed tw-flex-col tk-trade-gothic-next-condensed tw-w-[300px] tw-top-0 tw-bg-white tw-h-full" style={{ left: "250px" }}>
                            <svg onClick={toggleFilterPanel} className="tw-min-h-[53px] tw-h-[53px] tw-cursor-pointer tw-self-end tw-mb-[-8px]" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 24 30" style={{ enableBackground: "new 0 0 24 30" }} xmlSpace="preserve">
                                <path d="M8.6,15.4c0.2,0.2,0.5,0.2,0.7,0c0,0,0,0,0,0l2.6-2.6l2.6,2.7c0.2,0.2,0.5,0.2,0.7,0s0.2-0.5,0-0.7l0,0L12.7,12l2.7-2.6
	                    c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,0L12,11.3L9.4,8.6c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7l2.6,2.6l-2.6,2.6
	                    C8.5,14.8,8.5,15.2,8.6,15.4z" />
                            </svg>
                            <FilterArea setItemGroups={setItemGroups} setItemsLoading={setItemsLoading} />
                        </div>
                    </div>

                    : <FilterArea setItemGroups={setItemGroups} setItemsLoading={setItemsLoading} />
            )}
        </>
    );
})